import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePatch } from '../../../../../utils/AxiosUtil';
import ErrorAwareTextField from '../../../../common/inputfields/ErrorAwareTextField';

class ModifyRestrainPartner extends Component {

    state = {
        name: this.props.row.name,
        comment: this.props.row.comment,
        errors: new Map(),
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/restrainpartner';
        const requestObject = {
            "employeeId": this.props.row.employeeId,
            "name": this.state.name,
            "comment": this.state.comment,
            "privateId": this.props.row.privateId
        };

        handlePatch(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            disabled
                            name="employee"
                            label="Munkavállaló"
                            errors={this.state.errors}
                            value={this.props.row.employeeName} 
                            />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="name"
                            label="Partner neve"
                            errors={this.state.errors}
                            value={this.state.name}
                            prevValue={this.props.row.name}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            errors={this.state.errors}
                            value={this.state.comment}
                            prevValue={this.props.row.comment}
                            modify={true}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Mentés
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyRestrainPartner);
